import { useEffect, useRef } from 'react';

export const OtpStatesKey = 'OTP_STATES';
export const newEmailKey = 'NEW_EMAIL';

export type StateCodeItem = {
    value: string;
    expiration: number;
};

export function processStateCodesStr(stateCode: StateCodeItem) {
    const prevStateCodesStr = localStorage.getItem(OtpStatesKey);
    localStorage.removeItem(OtpStatesKey);
    if (prevStateCodesStr) {
        let prevStateCodes = JSON.parse(prevStateCodesStr) as StateCodeItem[];
        const currentTime = new Date().getTime();
        return prevStateCodes
            .concat(stateCode)
            .slice(-8)
            .filter(
                (value, index, self) =>
                    value.value !== '' &&
                    self.findIndex((item) => item.value === value.value) === index &&
                    value.expiration > currentTime,
            );
    } else {
        return [stateCode];
    }
}

export function setStateCodesToLocalStorage(stateCodes: StateCodeItem[]) {
    localStorage.setItem(OtpStatesKey, JSON.stringify(stateCodes));
}

export function setNewEmail(newEmail: string) {
    const savedNewEmail = localStorage.getItem(newEmailKey);
    if (newEmail === savedNewEmail) return;
    localStorage.removeItem(OtpStatesKey);
    localStorage.setItem(newEmailKey, newEmail);
}

export function getEmailFAQUrl(
    emailVerificationFAQUrls: Record<string, string> | string,
    locale: string,
): string | null {
    if (typeof emailVerificationFAQUrls === 'object') {
        return emailVerificationFAQUrls[locale];
    } else if (typeof emailVerificationFAQUrls === 'string') {
        return emailVerificationFAQUrls as string;
    } else {
        return null;
    }
}

export function usePrevious<T>(value: T) {
    const ref = useRef<T>();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}
